export const ChatUserType = {
  Unknown: 'Unknown',
  Caller: 'Caller',
  Dispatcher: 'Dispatcher',
} as const;

export type ChatUserType = (typeof ChatUserType)[keyof typeof ChatUserType];
